import { useEffect, useState } from 'react';
import axios from '../utils/axios';
import { DescriptionFormat } from '../landingPage/DescriptionFormat';

export type RegulatoryCard = {
    description?: string;
    descriptionFormat?: DescriptionFormat;
    websiteUrl?: string;
    logoUrl?: string;
    resourceLinks?: { label?: string; url?: string }[];
};

export function useMarketRegulatoryCard(marketId: number) {
    const [enabled, setEnabled] = useState<boolean | null>(null);
    const [card, setCard] = useState<RegulatoryCard | null>(null);

    useEffect(() => {
        let cancelled = false;
        setEnabled(null);
        setCard(null);
        axios.get(`/market/${marketId}/regulatory-card`).then(({ data }) => {
            if (cancelled) return;
            setEnabled(typeof data?.enabled === 'boolean' ? data.enabled : null);
            setCard(data?.card ?? null);
        }).catch(() => {
            if (!cancelled) {
                setEnabled(null);
                setCard(null);
            }
        });
        return () => { cancelled = true; };
    }, [marketId]);

    return { enabled, card };
}
